export const IDENTITY_DEFAULTS = {
  collectionId: "paddock",
  accentColor: "#e10600",
  qrDotStyle: "rounded",
  qrCornerSquareStyle: "extra-rounded",
  qrCornerDotStyle: "dot",
  centerLogo: "mbid",
  finish: "matte",
  showCarName: false,
  baseTheme: null
};

export const QR_DOT_STYLES = [
  { id: "square", label: "Square" },
  { id: "rounded", label: "Rounded" },
  { id: "dots", label: "Dots" },
  { id: "classy", label: "Classy" },
  { id: "classy-rounded", label: "Classy Rounded" },
  { id: "extra-rounded", label: "Extra Rounded" }
];

export const QR_CORNER_SQUARE_STYLES = ["square", "dot", "extra-rounded"];
export const QR_CORNER_DOT_STYLES = ["square", "dot"];
export const IDENTITY_FINISHES = ["matte", "gloss", "carbon-fiber", "forged-carbon", "brushed-metal", "minimal"];
export const IDENTITY_PREVIEW_MODES = [
  { id: "card", label: "Identity Card" },
  { id: "mirror", label: "Mirror Show Tag" },
  { id: "sticker", label: "Sticker" },
  { id: "qr", label: "QR Only" }
];

export const ACCENT_PRESETS = [
  ["MyBuildID Red", "#e10600"], ["Orange", "#ff6b00"], ["Yellow", "#ffd400"],
  ["Green", "#19c463"], ["Cyan", "#00cfe8"], ["Blue", "#2675ff"],
  ["Purple", "#8a4dff"], ["Pink", "#ff3b91"], ["White", "#ffffff"]
];

export function normalizeIdentityStudio(value = {}) {
  return {
    ...IDENTITY_DEFAULTS,
    collectionId: value.collectionId === "paddock" ? value.collectionId : IDENTITY_DEFAULTS.collectionId,
    accentColor: isValidHex(value.accentColor) ? value.accentColor.toLowerCase() : IDENTITY_DEFAULTS.accentColor,
    qrDotStyle: QR_DOT_STYLES.some((style) => style.id === value.qrDotStyle) ? value.qrDotStyle : IDENTITY_DEFAULTS.qrDotStyle,
    qrCornerSquareStyle: QR_CORNER_SQUARE_STYLES.includes(value.qrCornerSquareStyle) ? value.qrCornerSquareStyle : IDENTITY_DEFAULTS.qrCornerSquareStyle,
    qrCornerDotStyle: QR_CORNER_DOT_STYLES.includes(value.qrCornerDotStyle) ? value.qrCornerDotStyle : IDENTITY_DEFAULTS.qrCornerDotStyle,
    centerLogo: value.centerLogo === "none" ? "none" : "mbid",
    finish: IDENTITY_FINISHES.includes(value.finish) ? value.finish : IDENTITY_DEFAULTS.finish,
    showCarName: value.showCarName === true,
    baseTheme: ["light", "dark"].includes(value.baseTheme) ? value.baseTheme : null
  };
}

export function getResolvedBaseTheme(settings, mode) {
  if (["light", "dark"].includes(settings?.baseTheme)) return settings.baseTheme;
  return mode === "mirror" ? "light" : "dark";
}

export function isValidHex(value) { return /^#[0-9a-f]{6}$/i.test(value || ""); }

export function getScannableQrColor(accentColor) {
  const rgb = accentColor.slice(1).match(/.{2}/g).map((part) => parseInt(part, 16) / 255);
  const luminance = rgb.map((channel) => channel <= .03928 ? channel / 12.92 : ((channel + .055) / 1.055) ** 2.4)
    .reduce((sum, channel, index) => sum + channel * [.2126, .7152, .0722][index], 0);
  return 1.05 / (luminance + .05) >= 4.5 ? accentColor : "#111111";
}

export function getQrSafeColor(accentColor) {
  if (!isValidHex(accentColor)) return "#111111";
  const channels = accentColor.slice(1).match(/.{2}/g).map((part) => parseInt(part, 16));
  const contrast = qrContrast(channels);
  if (contrast >= 4.5) return accentColor.toLowerCase();
  for (let factor = .82; factor >= .2; factor -= .08) {
    const darker = channels.map((channel) => Math.round(channel * factor));
    if (qrContrast(darker) >= 4.5) return `#${darker.map((channel) => channel.toString(16).padStart(2, "0")).join("")}`;
  }
  return "#111111";
}

export function getMirrorScannableQrColor(accentColor) { return getQrSafeColor(accentColor); }

function qrContrast(channels) {
  const luminance = channels.map((channel) => channel / 255).map((channel) => channel <= .03928 ? channel / 12.92 : ((channel + .055) / 1.055) ** 2.4)
    .reduce((sum, channel, index) => sum + channel * [.2126, .7152, .0722][index], 0);
  return 1.05 / (luminance + .05);
}

export function finishLabel(value) {
  return value.split("-").map((part) => part[0].toUpperCase() + part.slice(1)).join(" ");
}
